import { render, staticRenderFns } from "./PUCImage.vue?vue&type=template&id=4dbe5748&scoped=true&"
import script from "./PUCImage.vue?vue&type=script&lang=js&"
export * from "./PUCImage.vue?vue&type=script&lang=js&"
import style0 from "./PUCImage.vue?vue&type=style&index=0&id=4dbe5748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe5748",
  null
  
)

export default component.exports